import { DisputeStatusCount } from '../models';
import { ModelResource } from './resource';

export class DisputeStatusCounts extends ModelResource<DisputeStatusCount> {
  model = DisputeStatusCount;

  resourcePath = 'v1/disputes/status';
}
